/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = [".header-logo-section[_ngcontent-%COMP%]   img[_ngcontent-%COMP%]{margin-top:25px}.header-logo-section[_ngcontent-%COMP%]   a[_ngcontent-%COMP%]{cursor:default}.body[_ngcontent-%COMP%]{margin-top:40px}"];
export { styles as styles };



// WEBPACK FOOTER //
// ./src/app/shared/templates/template1/themes/default/CSS/email-whitelist.component.less.shim.ngstyle.js.pre-build-optimizer.js